// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"29a1932f","666":"6504f030"}[chunkId] + ".chunk.css";
};